import { getProblemById, getFileSuffixByLanguageID } from "../Data/ProblemsMethod";

export default async function FetchStartingCode(ProblemID, LanguageID){
    const currProblem = getProblemById(ProblemID)
    const pathToCodeFolder = currProblem.path_to_code_folder;
    const FileNameLessLanguageSuffix = currProblem.problem_name.split(' ').join(''); // As a rule, staring code file name must match problem name
    const fileSuffix = getFileSuffixByLanguageID(LanguageID);
    const startingCodeFileName = FileNameLessLanguageSuffix + fileSuffix;
    const pathToStartingCode = pathToCodeFolder + startingCodeFileName;
    const startingCodeFetch = await fetch(pathToStartingCode);
    const startingCode = await startingCodeFetch.text();
    return startingCode;
}